import React from 'react';
import { Link } from 'react-router-dom';

export default function Register() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-lg shadow p-8 max-w-sm w-full text-center">
        <h1 className="text-xl font-bold text-gray-900 mb-2">Account Registration</h1>
        <p className="text-sm text-gray-500 mb-6">
          Keep Austin Mowed accounts are created by the admin. Contact Michael to get access.
        </p>
        <Link to="/login" className="text-green-600 hover:text-green-700 font-medium text-sm">
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
